export default __webpack_public_path__ + "static/media/Expected_Sales_Order_Template.a0d256c5.xlsx";